import { slideToggle } from '../general/startup/slide';
import { validateSearch } from '../general/utils/validation';

const magnav = document.querySelector('.magnav');

window.addEventListener('scroll', e => {
  if (magnav) {
    magnav.classList.toggle('scrolled', window.scrollY > 1);
  }
});
[].forEach.call(document.querySelectorAll('.back.btn'), function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    window.history.back();
    return false;
  });
});

const formTrigger = document.querySelector('.formtrigger');

if (formTrigger) {
  const form = formTrigger.parentNode.querySelector('form');
  const input = form.querySelector('input');
  const submitter = form.querySelector('button');
  formTrigger.classList.add('active');

  formTrigger.addEventListener('click', activateSearch);
  formTrigger.addEventListener('focusin', activateSearch);

  form.addEventListener('submit', () => {
    if (validateSearch.validateAll(form).length) {
      return;
    }
    submitter.classList.add('wait');
  });

  function activateSearch() {
    formTrigger.classList.remove('active');
    form.classList.add('active');
    input.focus();
  }
}

// --- MAGAZINE NAVIGATIONS

const magNavMobile = document.querySelector('.mobileNav');
const magNavMenu = document.querySelector('.magmenu');
const outer = document.querySelector('.magnav.section-nav');
if (magNavMobile) {
  magNavMobile.addEventListener('click', function (e) {
    slideToggle(magNavMenu, undefined, 350);
    magNavMobile.classList.toggle('active');
  });
}
if (outer && window.innerWidth < 1025) {
  const activeLink = magNavMenu.querySelector('.active');
  const scrollContainer = document.querySelector('.magnav .navigation');
  const position = activeLink.getBoundingClientRect();
  scrollContainer.scrollLeft = position.left - outer.getBoundingClientRect().width / 2 + position.width / 2;

  scrollContainer.onscroll = function () {
    if (scrollContainer.scrollLeft > 4) {
      outer.style.setProperty('--left-opacity', 1);
    } else {
      outer.style.setProperty('--left-opacity', 0);
    }
    if (magNavMenu.getBoundingClientRect().width + magNavMenu.getBoundingClientRect().left - outer.getBoundingClientRect().width < 30) {
      outer.style.setProperty('--right-opacity', 0);
    } else {
      outer.style.setProperty('--right-opacity', 1);
    }
  };
}

let activeDropdown = null;
let activeLink = null;

if (magNavMenu) {
  magNavMenu.querySelectorAll('li > a.navbutton').forEach(item => {
    item.addEventListener('click', e => {
      if (window.matchMedia('(min-width: 992px)').matches && item.nextElementSibling) {
        e.preventDefault();
      }
    });

    item.addEventListener('focusin', () => {
      if (activeLink !== item && activeDropdown) {
        activeDropdown.classList.remove('hover');
      }
      if (item.nextElementSibling) {
        activeDropdown = item.nextElementSibling;
        item.nextElementSibling.classList.add('hover');
      }
      activeLink = item;
    });

    if (item.nextElementSibling) {
      const subLinks = item.nextElementSibling.querySelectorAll('a');
      const lastSubLink = subLinks[subLinks.length - 1];
      lastSubLink.addEventListener('focusout', () => {
        activeDropdown.classList.remove('hover');
      });
    }
  });
}

// --- MAGAZINE SCROLLABLE TABLES

document.querySelectorAll('.scrollable-table').forEach(block => {
  const tableContent = block.querySelector('.content');
  const setTableScroll = () => {
    const width = block.querySelector('table').offsetWidth - tableContent.offsetWidth;
    const scrollPercent = width > 0 ? (100 * tableContent.scrollLeft) / width : 0;
    const left = scrollPercent < 2 ? 0 : 1;
    const right = scrollPercent > 98 || width <= 0 ? 0 : 1;
    block.style.setProperty('--left-opacity', left);
    block.style.setProperty('--right-opacity', right);
  };

  tableContent.addEventListener('scroll', setTableScroll);
  window.addEventListener('resize', setTableScroll);
  document.addEventListener('DOMContentLoaded', setTableScroll);
  window.addEventListener('customLoaded', setTableScroll);
});
